import { isValid } from 'date-fns';

export const getTimeFromDate = (date?: Date): string => {
  if (!date || !isValid(date)) return '';

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
};
